<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Tool.Setting')"
    :width="$selectByLang('600px', '600px', '600px', '700px', '700px', '700px')"
    :close-on-click-modal="false"
    class="block-set-dialog"
  >
    <el-form label-width="100px">
      <el-form-item :label="$t('SystemMaintenance.SetAlias')">
        <el-input v-model="selectedLanguage.customLabel" :disabled="block.branchId!==1" :placeholder="selectedLanguage.sysLabel" style="width: 250px;margin-right: 5px" />
        <el-button v-for="(item, index) in languageItems" :key="index" :type="selectedLanguage===item?'primary':'info'" @click="selectedLanguage=item">{{ item.name }}</el-button>
      </el-form-item>
      <el-form-item label=" " style="margin-top: -2px;">
        <span>
          <i class="el-icon-warning" style="color: #e6a23c;" />
          {{ $t('SystemMaintenance.AliasOnlyHQ') }}
        </span>
      </el-form-item>
      <el-form-item label=" " style="margin-top: 20px;">
        <el-checkbox v-model="hide" :disabled="hasDisplayElement">{{ $t('SystemMaintenance.HideCategoryAllLanguage') }}</el-checkbox>
      </el-form-item>
      <el-form-item label=" " style="margin-top: -5px;">
        <span>
          <i class="el-icon-warning" style="color: #e6a23c;" />
          {{ $t('SystemMaintenance.FieldDisplayHideForbid') }}
        </span>
      </el-form-item>
      <template v-if="blockWidthEnabled">
        <el-form-item :label="$t('SystemMaintenance.SetBlockWidth')" style="margin-top: 20px;">
          <el-input-number v-model="blockWidth" :min="blockWidthMin" :max="blockWidthMax" :precision="0" :controls="false" style="width: 250px" />
        </el-form-item>
        <el-form-item label=" " style="margin-top: -2px;">
          <span>
            <i class="el-icon-warning" style="color: #e6a23c;" />
            {{ $t('SystemMaintenance.SettableRange300400') }}
          </span>
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="okHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'

export default {
  name: 'BlockSetDialog',
  props: {
    visible: { type: Boolean, required: true },
    block: { type: Object, required: true }
  },
  data() {
    const languageItems = [
      { language: 'zh_CN', name: this.$t('Tool.Chinese'), sysLabel: '', customLabel: '' },
      { language: 'en_US', name: this.$t('Tool.English'), sysLabel: '', customLabel: '' },
      { language: 'ja_JP', name: this.$t('Tool.Japanese'), sysLabel: '', customLabel: '' }
    ]
    const languageDict = {}
    for (const item of languageItems) {
      languageDict[item.language] = item
    }
    return {
      innerVisible: false,
      languageItems,
      languageDict,
      selectedLanguage: languageItems[0],
      hide: false,
      hasDisplayElement: false,
      blockWidthEnabled: false,
      blockWidthMin: 0,
      blockWidthMax: 0,
      blockWidth: 0
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          const sysLanguages = this.block.pagePart.languageList
          const customLanguages = this.block.languageList
          if (sysLanguages && sysLanguages.length > 0) {
            for (const item of sysLanguages) {
              if (!this.languageDict[item.language]) {
                continue
              }
              this.languageDict[item.language].sysLabel = item.name
            }
          }
          if (customLanguages && customLanguages.length > 0) {
            for (const item of customLanguages) {
              if (!this.languageDict[item.language]) {
                continue
              }
              this.languageDict[item.language].customLabel = item.name
            }
          }
          this.selectedLanguage = this.languageItems[0]
          this.hasDisplayElement = this.block.uiCustomElementList.findIndex(p => p.isDisplay) > -1
          if (this.hasDisplayElement) {
            this.hide = false
          } else {
            this.hide = this.block.hide
          }
          const blockWidthSetting = UICustomUtil.getBlockWidthSetting(this.block)
          if (blockWidthSetting) {
            this.blockWidthEnabled = true
            this.blockWidthMin = blockWidthSetting.min
            this.blockWidthMax = blockWidthSetting.max
            this.blockWidth = blockWidthSetting.value
          }
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        for (const item of this.languageItems) {
          item.sysLabel = ''
          item.customLabel = ''
        }
        this.blockWidthEnabled = false
        this.blockWidthMin = 0
        this.blockWidthMax = 0
        this.blockWidth = 0
      }
    }
  },
  methods: {
    okHandler() {
      if (!this.block.languageList) {
        this.block.languageList = []
      }
      for (const item of this.languageItems) {
        const language = this.block.languageList.find(p => p.language === item.language)
        if (language) {
          language.name = item.customLabel
        } else {
          this.block.languageList.push({ type: 4, relatedUuid: this.block.uuid, language: item.language, name: item.customLabel })
        }
        if (item.language.startsWith(this.$store.getters.language)) {
          this.block.customLabel = item.customLabel
        }
      }
      this.block.hide = this.hide
      this.block.width = this.blockWidth
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
#app .block-set-dialog::v-deep {
  .el-input-number .el-input input {
    text-align: left;
  }
}
</style>
